export default __webpack_public_path__ + "4f204ca695952e1df73d5f3195db7377.png";